import { FilterService } from 'primereact/api';
import { ObjectUtils } from 'primereact/utils';

/**
 * Filtros escritos en los encabezados de la grilla (ej. Alertas Tramo Puerto = ALERTA), aplicados igual que los
 * aplica la tabla. Sin esto el Excel salía con todas las filas aunque la grilla mostrara solo las filtradas.
 */
export const aplicarFiltrosColumna = (lista, filters) => (lista || []).filter(f => Object.entries(filters || {}).every(([campo, meta]) => {
    const valor = meta ? meta.value : null;
    if (valor === null || valor === undefined || valor === '') return true;
    const fn = FilterService.filters[meta.matchMode];
    return fn ? fn(ObjectUtils.resolveFieldData(f, campo), valor) : true;
}));

/** Azul del viaje LLENO hasta R10. */
export const COLOR_LLENO = '#2196F3';

/**
 * Color de cada etapa después de R10 en el visor de recorrido. Pedido de DOLE (31/10/2026): no queda ningún tramo
 * gris; lo que el motor llama EN R10 (antes de F1, o antes de F2 si no hubo F1) sigue en el azul del LLENO y el rojo
 * de RUTA PUERTO arranca en F1, cuando el candado se vuelve a cerrar en R10.
 */
export const COLOR_ETAPA = {
    'EN R10': COLOR_LLENO,
    'RUTA PUERTO': '#e53935',
    'EN PUERTO': '#FB8C00',
    'RUTA DEPOT': '#8E24AA',
    'CERRADO': '#2E7D32'
};

/**
 * Parte la traza de un candado en tramos consecutivos de la misma etapa (EN R10, RUTA PUERTO, EN PUERTO,
 * RUTA DEPOT) para pintar cada uno de otro color. Cada tramo empieza donde terminó el anterior, así la línea
 * no queda cortada en el cambio de etapa.
 */
export const tramosPorEtapa = (pts) => {
    const out = [];
    pts.forEach(p => {
        const ult = out[out.length - 1];
        if (ult && ult.etapa === p.etapa) {
            ult.path.push(p);
        } else {
            if (ult) ult.path.push(p);
            out.push({ etapa: p.etapa, path: [p] });
        }
    });
    return out.filter(t => t.path.length > 1);
};
